import { FC } from 'react'
import { Menu, Skeleton } from 'antd'
import { Link } from 'react-router-dom'
import { useWorkspace } from 'hooks/useWorkspace'
import { useWorkspaceLogoSize } from 'hooks/useWorkspaceLogoSize'
import { AppRoutes } from 'app/app-routes'
import Flex from 'antd/es/flex'

type Props = {
  isCollapsed?: boolean
  onWorkspaceClick?: () => void
}

const WorkspaceMenu: FC<Props> = ({ isCollapsed, onWorkspaceClick }) => {
  const { currentWorkspace, workspaces, isLoading } = useWorkspace()
  const { width: logoWidth, height: logoHeight, isReady } = useWorkspaceLogoSize(isCollapsed)

  const showSkeleton = isLoading || !isReady

  return (
    <Menu
      theme="light"
      triggerSubMenuAction="click"
      style={{ border: 'none' }}
      defaultSelectedKeys={[location.pathname]}
      items={[
        {
          key: 'workspace',
          label: showSkeleton ? (
            <Skeleton.Avatar active size={40} shape="square" />
          ) : (
            <img
              src={currentWorkspace?.logoUrl}
              alt={currentWorkspace?.name}
              style={{ height: logoHeight, width: logoWidth }}
              className="object-contain"
            />
          ),
          popupClassName:
            'min-w-64 [&_.ant-menu-item]:!h-[40px] [&_.ant-menu-item]:!flex [&_.ant-menu-item]:items-center !max-w-[290px] sm:!max-w-[450px] workspace-popup-position',
          className: `[&_.ant-menu-submenu-title]:!flex [&_.ant-menu-submenu-title]:!items-center [&_.ant-menu-submenu-title]:!overflow-visible [&_.ant-menu-submenu-title]:!mx-0 [&_.ant-menu-submenu-title]:!my-0 [&_.ant-menu-title-content]:!overflow-visible [&_.ant-menu-submenu-title]:!p-0 [&_.ant-menu-submenu-title]:!h-10 [&_.ant-menu-submenu-title]:!w-auto ${isCollapsed ? '[&_.ant-menu-submenu-title]:!max-w-[60px]' : ''} [&_.ant-menu-submenu-arrow]:!hidden`,
          ...(workspaces?.length && {
            children: workspaces?.map((item) => ({
              key: item?.id,
              label: (
                <Link
                  to={`${AppRoutes.workspaces}/${item.id}/space`}
                  onClick={onWorkspaceClick}
                  className="block min-w-0"
                >
                  <Flex gap={10} align="center">
                    <img src={item?.logoUrl} alt={item?.name} className="object-contain max-h-[30px]" />
                    <div className="font-semibold text-base whitespace-nowrap text-ellipsis overflow-hidden max-w-[210px] sm:max-w-[370px]">
                      {item?.name}
                    </div>
                  </Flex>
                </Link>
              )
            }))
          })
        }
      ]}
    />
  )
}

export default WorkspaceMenu
